/*
 * @Author: Json Chen
 * @Date: 2021-07-21 10:38:49
 * @LastEditTime: 2022-08-19 13:13:50
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Localisation/config.ts
 */

import moment from 'moment';

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/localisation',
    name: getI18n('storeLocalisation.config.localisation'),
  },
];

const dateFormatList = [
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'YYYY/MM/DD',
  'MMDDYYYY',
  'DDMMYYYY',
  'YYYYMMDD',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'YYYY-MM-DD',
];
const timeFormatList = [
  {
    format: 'HH:mm',
    value: 'HH:MM',
    desc: '24-hour time, HH:MM',
  },
  {
    format: 'hh:mm A',
    value: 'HH:MM XM',
    desc: '12-hour time, HH:MM XM',
  },
];

export const dateFormatOptions = dateFormatList.map((d) => ({
  label: `${d} (${moment().format(d)})`,
  value: d,
}));

export const timeFormatOptions = timeFormatList.map((t) => ({
  label: `${t.desc} (${moment().format(t.format)})`,
  value: t.value,
}));

export const decimalSeparatorOptions = [
  {
    labelKey: 'general.decimalpoint',
    value: 'POINT',
  },
  {
    labelKey: 'general.decimalcomma',
    value: 'COMMA',
  },
];
export const thousandsSeparatorOptions = [
  {
    labelKey: 'general.notuse',
    value: 'NOT_USE',
  },
  {
    labelKey: 'general.comma',
    value: 'COMMA',
  },
  {
    labelKey: 'general.point',
    value: 'POINT',
  },
  {
    labelKey: 'general.space',
    value: 'SPACE',
  },
];

export enum FieldType {
  Subdivision = 'Subdivision',
  City = 'City',
  Postcode = 'Postcode',
  AddressLine1 = 'AddressLine1',
  AddressLine2 = 'AddressLine2',
}

export const checkboxOptions = ({ getI18n }) => [
  {
    fieldType: FieldType.AddressLine1,
    fieldName: 'Street Address',
    addressField: getI18n('storeLocalisation.config.addressLine1'),
    checkedable: false,
  },
  {
    fieldType: FieldType.AddressLine2,
    fieldName: 'Suburb',
    addressField: getI18n('storeLocalisation.config.addressLine2'),
    checkedable: true,
  },
  {
    fieldType: FieldType.City,
    fieldName: 'City',
    addressField: getI18n('storeLocalisation.config.city'),
    // 可勾选
    checkedable: true,
  },
  {
    fieldType: FieldType.Subdivision,
    fieldName: 'State',
    addressField: getI18n('storeLocalisation.config.provinceStateDistrict'),
    // 不可勾选,默认有
    checkedable: false,
  },
  {
    fieldType: FieldType.Postcode,
    fieldName: 'Postcode',
    addressField: getI18n('storeLocalisation.config.postcode'),
    checkedable: true,
  },
];
